import {AbstractService} from 'services/AbstractService';
import sellerStore from 'store/indexSeller';

const GET_CAMPAIGNS_URL = '/api/seller/campaigns';
const GET_METRICS_URL = '/api/projects/{0}/bidmanager/groups/progress';
const GET_PLACEMENT_TYPES_URL = '/api/repos/placementtypes';
const CHANGE_CAMPAIGN_STATUS = '/api/placements/{0}/status';
const SWITCH_STRATEGY_STATUS = '/api/projects/{0}/bidmanager/groups/enabled';
const FETCH_DETAIL_GROUP = '/api/projects/{0}/bidmanager/groups/{1}';
const ACCOUNT_CHANNELS_URL = '/api/accounts/channels';
const CREATE_AUTOSTRATEGY_URL = '/api/projects/{0}/bidmanager/groups';
const CHANGE_SETTING_AUTOSTRATEGY_URL = '/api/projects/{0}/bidmanager/groups/{1}';
const GET_VALUES_FOR_AUTO_FILLER_URL = 'api/seller/bidmanager/values';
const REFRESH_PLACEMENT_LIST_URL = 'api/seller/bind_placement';
const PENDING_PLACEMENTS_LIST_URL = 'api/projects/{0}/placements/pending';

export class CampaignsSellerService extends AbstractService {
  getCampaignsCurrentUser (params) {
    return this.client.get(GET_CAMPAIGNS_URL, params);
  }

  getMetricsForCampaigns () {
    const projectId = sellerStore.getters['sellerUser/getProjectId'];

    return this.client.get(GET_METRICS_URL.format(projectId));
  }

  createAutostrategy (params) {
    const projectId = sellerStore.getters['sellerUser/getProjectId'];

    return this.client.post(CREATE_AUTOSTRATEGY_URL.format(projectId), params);
  }

  changeSettingAutostrategy (params) {
    const projectId = sellerStore.getters['sellerUser/getProjectId'];
    const groupId = params.id;

    return this.client.put(CHANGE_SETTING_AUTOSTRATEGY_URL.format(projectId, groupId), params);
  }

  getPlacementTypesFromRepos () {
    return this.client.get(GET_PLACEMENT_TYPES_URL);
  }

  changeCampaignStatus (payload) {
    return this.client.put(CHANGE_CAMPAIGN_STATUS.format(payload.id), payload);
  }

  enabledStrategy (payload) {
    const projectId = sellerStore.getters['sellerUser/getProjectId'];
    const accountId = sellerStore.getters['sellerUser/getAccountId'];

    return this.client.put(
      SWITCH_STRATEGY_STATUS.format(projectId),
      {project_id: projectId},
      {accountId},
      {params: {id: payload.strategy_id}}
    );
  }

  disabledStrategy (payload) {
    const projectId = sellerStore.getters['sellerUser/getProjectId'];
    const accountId = sellerStore.getters['sellerUser/getAccountId'];

    return this.client.delete(
      SWITCH_STRATEGY_STATUS.format(projectId),
      {id: payload.strategy_id},
      {accountId}
    );
  }

  async getCurrentChannelsList () {
    const accountId = sellerStore.getters['sellerUser/getAccountId'];
    return this.client.get(ACCOUNT_CHANNELS_URL, {account_id: accountId});
  }

  async fetchDetailGroup (groupId) {
    const projectId = sellerStore.getters['sellerUser/getProjectId'];
    return this.client.get(FETCH_DETAIL_GROUP.format(projectId, groupId));
  }

  getAutoFillValues (payload) {
    const {
      autostrategy,
      placement_id
    } = payload;

    return this.client.get(GET_VALUES_FOR_AUTO_FILLER_URL, {
      autostrategy,
      placement_id
    });
  }

  refreshPlacementList () {
    return this.client.post(REFRESH_PLACEMENT_LIST_URL);
  }

  pendingPlacementList () {
    const projectId = sellerStore.getters['sellerUser/getProjectId'];
    return this.client.get(PENDING_PLACEMENTS_LIST_URL.format(projectId));
  }
}
